import { useEffect, useState } from "react";
import { BellOff, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";

const KINDS = [
  ["alerts", "New grant matches and weekly grant prep updates"],
  ["reminders", "Deadline and due-date reminders"],
  ["updates", "Proposal, document and lender inquiry updates"],
  ["tips", "Tips, next-step nudges and check-ins"],
];

export function EmailSettings({ onAllOff }) {
  const [p, setP] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get("/me/email-prefs").then((r) => setP(r.data)).catch(() => setErr(true)); }, []);
  if (err) return <div className="bg-white border border-slate-200 rounded-lg p-6 text-sm text-slate-500" id="notifications" data-testid="email-settings-error">Couldn't load your email settings. Refresh the page to try again.</div>;
  if (!p) return null;
  const set = async (k, v) => {
    setP((cur) => ({ ...cur, [k]: v }));
    try { const { data } = await api.put("/me/email-prefs", { [k]: v }); setP(data); toast.success(v ? "Emails turned on" : "Emails turned off"); }
    catch (e) { toast.error(formatErr(e)); setP((cur) => ({ ...cur, [k]: !v })); }
  };
  const allOff = async () => {
    try { const { data } = await api.post("/me/notifications/all-off"); setP(data.email); onAllOff?.(); toast.success("All emails and texts are off. You'll still get sign-in and billing emails."); }
    catch (e) { toast.error(formatErr(e)); }
  };
  return (
    <div className="bg-white border border-slate-200 rounded-lg p-6 scroll-mt-20" id="notifications" data-testid="email-settings">
      <div className="flex items-center gap-2"><Mail className="h-5 w-5 text-emerald-600" /><h3 className="font-semibold text-slate-900">Email notifications</h3>
        <Button variant="outline" size="sm" className="ml-auto" onClick={allOff} data-testid="notifications-all-off-button"><BellOff className="h-4 w-4 mr-2" />Turn off all notifications</Button></div>
      <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-3">
        {KINDS.map(([k, label]) => (
          <label key={k} className="flex items-center gap-3 text-sm text-slate-700"><Switch checked={p[k]} onCheckedChange={(v) => set(k, v)} data-testid={`email-pref-${k}-switch`} />{label}</label>))}
      </div>
      <p className="text-xs text-slate-400 mt-3">Sign-in, security and billing emails are always sent.</p>
    </div>
  );
}
